import React from 'react';
import Icon from '../icon';
import AdvancedSearchButton from './components/advanced-search-button';
import AdvancedSearch from './components/advanced-search';
import Input from '../input';
import './index.css';

function SearchBar (props) {

	const {
		advancedSearchMode,
		isAdvancedSearchDropDown,
		advancedSearchDropDownHandler,
		advancedSearchContent
	} = props;

	return (
		<div className={`search-bar${props.className ? ' ' + props.className : ''}`} style={{width: props.width ? props.width + 'px' : '100%'}}>
			<label className={`m-0 mr-3${props.srOnly ? ' sr-only' : ''}`} htmlFor={props.id}>{props.label}</label>
			<Icon className="mr-0" name="search"/>
			<Input
				style={{width: props.width ? props.width + 'px' : '100%'}}
				id={props.id}
				title={props.title}
				type="text"
				disabled={props.disabled}
				onFocus={props.onFocus}
				onChange={props.onChange}
                onKeyPress={props.onKeyPress}
                placeholder={props.placeholder}
				value={props.value}
			/>
			{advancedSearchMode && <AdvancedSearchButton onClick={advancedSearchDropDownHandler}/>}
			{isAdvancedSearchDropDown && <AdvancedSearch>
				{advancedSearchContent}
			</AdvancedSearch>}
		</div>
	)
};

export default SearchBar;
